//import moment from 'moment';
import moment from "moment-timezone";
import { getLocalizedNameWithIntl, getLangFromCookies } from "../../../globals/langHelpers";

const initialShortestMonths = moment.monthsShort();

/*Value Formatters ---------------- Start*/
export const fkFormatter = (intl) => (params) => {
    return getLocalizedNameWithIntl(intl, {
        object: params.value,
        defaultString: " ",
    });
};

export const dateFormatter = (params, nullValue) =>
    params.value ? moment.utc(new Date(params.value)).add(-moment().utcOffset(), "minutes").format("MMM DD, YYYY") : nullValue;

export const dateTimeFormatter = (params, nullValue) =>
    params.value ? moment.utc(params.value).add(-moment().utcOffset(), "minutes").format("MMM DD, YYYY h:mm a") : nullValue;

export const valueDateTimeFormatter = (params, nullValue) =>
    params.value ? moment.utc(params.value).add(-moment().utcOffset(), "minutes").format("MMM DD, YYYY") : nullValue;
export const dateTimeSecValueFormatters = (params, nullValue) => {
    return params.value
        ? moment.utc(new Date(params.value)).tz("America/Toronto").add(moment().utcOffset(), "minutes").format("MMM D, YYYY, h:mm a")
        : nullValue;
};
export const dateTimeStampValueFormatter = (params, nullValue) => {
    return params.value ? moment.utc(new Date(params.value)).add(moment().utcOffset(), "minutes").format("MMM D, YYYY, h:mm a") : nullValue;
};
export const dateTimeStampValueFormatters = (params, nullValue) => {
    return params.value ? moment.utc(params.value).add(moment().utcOffset(), "minutes").local().format("MMM D, YYYY, h:mm a") : nullValue;
};
export const dateTimeSecValueFormatter = (params, nullValue) =>
    params.value ? moment.utc(params.value).add(moment().utcOffset(), "minutes").format("MMM DD, YYYY h:mm a") : nullValue;

export const dateTimeValueFormatter = (params, nullValue) =>
    params.value ? moment.utc(params.value).add(moment().utcOffset(), "minutes").format("MMM D, YYYY") : nullValue;
export const dateTimeValueFormatters = (params, nullValue) =>
    params.value ? moment.utc(new Date(params.value)).tz("America/Toronto").add(moment().utcOffset(), "minutes").format("MMM D, YYYY") : nullValue;
export const valueDateFormatter = (params, nullValue) => (params.value ? moment.utc(params.value).format("MMM DD, YYYY") : nullValue);

export const phoneNumberFormatter = (params, nullValue) => (params && params.value ? formatPhoneNumber(params.value) : nullValue);

export const phoneNumberFormatterValue = (params, nullValue) => (params ? formatPhoneNumber(params) : nullValue);

export const formatPhoneNumber = (value) => {
    if (!value) return "";
    let phone = value;
    //normalize string and remove all unnecessary characters
    phone = phone.replace(/[^\d]/g, "");

    //check if number length equals to 10
    if (phone.length == 10) {
        //reformat and return phone number
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }
    return value;
};

export const dateFormatterNotif = (params, nullValue) =>
    params.value ? moment.utc(new Date(params.value)).add(-moment().utcOffset(), "minutes").format("MMM D, YYYY, h:mmA") : nullValue;

export const cumulativeCost = (params) => {
    const val = params?.value?.toString();
    return val.indexOf(".") == -1 ? val : Number(val).toFixed("2");
};
/*Value Formatters ---------------- End*/

/*Sort Formatters ------------- Start*/
export const oddComparator = (v1, v2) => new Date(v1) - new Date(v2);

export const dateComparator = (v1, v2) => v1 - v2;

export const sortAlphaNumComparator = (intl) => (v1, v2) => {
    return v1?.localeCompare(v2, intl?.locale, { numeric: true });
};

export const sortValueComparator = (intl) => (v1, v2) => {
    return v1?.localeCompare(v2, intl?.locale, { sensitivity: "base" });
};

export const fkComparator = (intl) => (v1, v2, r1, r2) => {
    if (v1.sortOrder !== undefined && v2.sortOrder !== undefined) {
        return parseInt(v1.sortOrder) - parseInt(v2.sortOrder);
    }
    var name1 = v1 ? getLocalizedNameWithIntl(intl, { object: v1 }) + " " + getLocalizedNameWithIntl(intl, { object: v1 }) : "";
    var name2 = v2 ? getLocalizedNameWithIntl(intl, { object: v2 }) + " " + getLocalizedNameWithIntl(intl, { object: v2 }) : "";
    return name1.localeCompare(name2, intl.locale, { sensitivity: "base" }); // default to alphabetical if sortOrder undefined
};

export const assignToComparator = (intl) => (v1, v2) => {
    var name1 = v1 ? (v1.firstName ? v1.firstName : "Unassigned") + " " + (v1.lastName ? v1.lastName : "") : "";
    var name2 = v2 ? (v2.firstName ? v2.firstName : "Unassigned") + " " + (v2.lastName ? v2.lastName : "") : "";
    return name1.localeCompare(name2, intl?.locale, { sensitivity: "base" });
};
/*Sort Formatters ------------- End*/

/*Excel Formatters ---------------- Start*/
const revertTemporarilyShortestMonthsBack = () => {
    const currentLangIsEnglish = getLangFromCookies() === "en";
    if (!currentLangIsEnglish && initialShortestMonths) moment.locale("fr", { monthsShort: initialShortestMonths.toString().split(",") });

    setTimeout(() => {
        if (!currentLangIsEnglish) moment.locale("fr", { monthsShort: "janv_févr_mars_avr_mai_juin_juil_août_sept_oct_nov_déc".split("_") });
    }, 2000);

    return true;
};

export const dateTimeExcelFormatter = (params) => {
    revertTemporarilyShortestMonthsBack();

    const currentLangIsEnglish = getLangFromCookies() === "en";
    const dateFormatToUse = currentLangIsEnglish ? "D[-]MMM[-]YYYY" : "D[-]MM[-]YYYY";

    return params.value ? moment.utc(new Date(params.value)).add(moment().utcOffset(), "minutes").format(dateFormatToUse) : "";
};
export const dateTimeExcelFormatters = (params) => {
    revertTemporarilyShortestMonthsBack();

    const currentLangIsEnglish = getLangFromCookies() === "en";
    const dateFormatToUse = currentLangIsEnglish ? "D[-]MMM[-]YYYY" : "D[-]MM[-]YYYY";

    return params.value ? moment.utc(new Date(params.value)).tz("America/Toronto").add(moment().utcOffset(), "minutes").format(dateFormatToUse) : "";
};
//export const dateTimeSecExcelFormatter = (params) => (params.value ? moment.utc(params.value).add(moment().utcOffset(), "minutes").format("D[-]MMM[-]YYYY, h:mm a") : "");
export const dateTimeSecExcelFormatters = (params) => {
    revertTemporarilyShortestMonthsBack();

    const currentLangIsEnglish = getLangFromCookies() === "en";
    const dateFormatToUse = currentLangIsEnglish ? "D[-]MMM[-]YYYY h:mm a" : "D[-]MM[-]YYYY HH:mm:ss";

    return params.value ? moment.utc(new Date(params.value)).tz("America/Toronto").add(moment().utcOffset(), "minutes").format(dateFormatToUse) : "";
};
export const dateTimeStampExcelFormatter = (params) => {
    revertTemporarilyShortestMonthsBack();

    const currentLangIsEnglish = getLangFromCookies() === "en";
    const dateFormatToUse = currentLangIsEnglish ? "D[-]MMM[-]YYYY h:mm a" : "D[-]MM[-]YYYY HH:mm:ss";

    return params.value ? moment.utc(new Date(params.value)).add(moment().utcOffset(), "minutes").format(dateFormatToUse).toString() : "";
};
export const dateTimeStampExcelFormatters = (params) => {
    revertTemporarilyShortestMonthsBack();

    const currentLangIsEnglish = getLangFromCookies() === "en";
    const dateFormatToUse = currentLangIsEnglish ? "D[-]MMM[-]YYYY h:mm a" : "D[-]MM[-]YYYY HH:mm:ss";
    return params.value
        ? moment.utc(params.value).add(moment().utcOffset(), "minutes").subtract(60, "minutes").local().format(dateFormatToUse).toString()
        : "";
};
export const excelDateFormatter = (params) => {
    return params.value ? moment(new Date(params.value)).format("D[-]MMM[-]YYYY") : "";
};

export const excelDateTimeFormatter = (params) => {
    return params.value ? moment(new Date(params.value)).format("YYYY-MM-DD hh:mm:ss") : "";
};

export const localeExcelFormatter = (params, field) => {
    return params.value ? params.value : "";
};

export const localeExcelDateFormatter = (params, field) => {
    return params.value ? moment(new Date(params.value)).format("YYYY-MM-DD") : "";
};

export const excelCostFormatter = (params) => {
    return params.value ? params.value : "";
};

// Filtering of datalist rows
export const getRowValue = (row, field) => {
    const value = row[field.field];
    if (field.valueFormatter) {
        return field.valueFormatter({
            value,
            row,
        });
    }
    return value;
};

export const filterRows = (rows, filters = {}) => {
    const filterFields = Object.keys(filters);
    if (!filterFields.length) return rows;
    let filteredRows = rows;
    filterFields.forEach((col) => {
        const filter = filters[col];
        const { field, selectedItems } = filter;
        if (selectedItems && selectedItems.length > 0) {
            filteredRows = filteredRows.filter((task) => {
                const value = getRowValue(task, field);
                return selectedItems.includes(value === null ? "" : value);
            });
        }
    });
    return filteredRows;
};
